import React, { useState, useEffect, useRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import FormatQuote from '@material-ui/icons/FormatQuote';

// import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import AfitdTextField from '../../common/elemental/AfitdTextField';
import AfitdIconButton from '../../common/elemental/AfitdIconButton';

// import cx from 'clsx';
// import _get from 'lodash/get';
// import _set from 'lodash/set';

const styles = theme => ({
    root: {
        marginTop: '10px',
        marginRight: '24px',
        display: 'flex',
    },
    note: {
        flexGrow: 1,
    },
    noteInputRoot: {
        paddingRight: '10px',
    },
    noteInput: {
        fontSize: '14px',
    },
    noteHelperText: {
        textAlign: 'right',
    },
    noteStartAdornmentIcon: {
        color: 'rgba(0, 0, 0, 0.54)',
    },
    noteIconButtonContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: '28px',
    },
    noteCloseIconButton: {
        padding: '5px',
    },
    noteCloseIcon: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: '14px',
    },
    noteSaveIconButton: {
        padding: '5px',
    },
    noteSaveIcon: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: '14px',
    },
});

const getDefns = params => {
    const { props, onSave, onCancel, isEnabled, setIsEnabled, note, setNote } = params;
    const { classes } = props;
    const {
        noteInput: noteInputCls,
        noteInputRoot: noteInputRootCls,
        noteHelperText: noteHelperTextCls,
        noteStartAdornmentIcon: noteStartAdornmentIconCls,
        ...otherClasses
    } = classes;

    //--------------------------------------------------------------------
    // TEMP data
    // const interviewStatus = INTERVIEW_STATUS_PENDING;
    // const now = new Date();
    // const startDt = now;
    // const companyName = 'The Matrix';
    // const pocName = 'Thomas Anderson';
    // const jobTitle = 'Business Analyst';
    // const virtual = Math.floor(Math.random() * Math.floor(10)) >= 5;
    // const address = "700 L'Enfant Plaza SW, Washington, DC 20024";
    // const note = 'The Matrix has me';
    //--------------------------------------------------------------------

    const noteHelperText = `${note ? note.length : 0}/200`;

    let defns = {
        note: {
            fullWidth: true,
            variant: 'outlined',
            size: 'small',
            multiline: true,
            helperText: noteHelperText,
            InputProps: {
                readOnly: !isEnabled,
                classes: {
                    root: noteInputRootCls,
                    input: noteInputCls,
                },
                startAdornment: (
                    <InputAdornment position="start">
                        <FormatQuote className={noteStartAdornmentIconCls} />
                    </InputAdornment>
                ),
            },
            inputProps: {
                maxLength: 200,
            },
            FormHelperTextProps: {
                className: noteHelperTextCls,
            },
            value: note,
            // isHidden: noteIsHidden,
            onClick: handleClickNote.bind(null, isEnabled, setIsEnabled),
            onChange: handleChangeNote.bind(null, setNote),
        },
        noteSaveIconButton: {
            isHidden: !isEnabled,
            onClick: onSave.bind(null, note),
        },
        noteCloseIconButton: {
            isHidden: !isEnabled,
            onClick: onCancel,
        },
    };

    setClassNameInDefns(defns, otherClasses);

    return defns;
};

const focusOnNote = (noteInputEl, note) => {
    if (noteInputEl.current) {
        noteInputEl.current.focus();
        noteInputEl.current.value = '';
        noteInputEl.current.value = note;
    }
};

const handleClickNote = (isEnabled, setIsEnabled) => {
    if (!isEnabled) {
        setIsEnabled(true);
    }
};

const handleChangeNote = (setNote, evt) => {
    setNote(evt.target.value);
};

const InterviewNote = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    // const context = useContext(LayoutContext);
    const noteInputEl = useRef();
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    const { isHidden, isEnabled, setIsEnabled, value, onCancel, onSave } = props;
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    const [note, setNote] = useState(value);
    const [requestFocus, setRequestFocus] = useState(false);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    useEffect(() => {
        // reset note to the passed in value (db value)
        setNote(value);
    }, [value, isEnabled]);

    useEffect(() => {
        // every time enabled, set focus (for convenience)
        if (isEnabled) {
            setRequestFocus(true);
        }
    }, [isEnabled]);

    useEffect(() => {
        // if requested focus, set focus and set requestFocus to false
        if (requestFocus) {
            focusOnNote(noteInputEl, note);
            setRequestFocus(false);
        }
    }, [requestFocus, noteInputEl, note]);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    const defns = getDefns({
        props,
        value,
        onSave,
        onCancel,
        isEnabled,
        setIsEnabled,
        note,
        setNote,
    });
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    if (isHidden) {
        return null;
    } else {
        return (
            <div {...defns.root}>
                <AfitdTextField {...defns.note} inputRef={noteInputEl} />
                <div {...defns.noteIconButtonContainer}>
                    <AfitdIconButton {...defns.noteSaveIconButton}>
                        <CheckIcon {...defns.noteSaveIcon} />
                    </AfitdIconButton>
                    <AfitdIconButton {...defns.noteCloseIconButton}>
                        <CloseIcon {...defns.noteCloseIcon} />
                    </AfitdIconButton>
                </div>
            </div>
        );
    }
    //---------------------------------------------------------------------
};

export default withStyles(styles)(InterviewNote);
